import React, { createContext, useState, Dispatch } from 'react';

interface ProviderProps {
  children: JSX.Element;
}

export interface PublishedTests {
  testId: number;
  createdBy: number;
  createdByName: null | string | number;
  testDate: string;
  date: string;
  time: string;
  status: string;
  subjectId: number;
  code: string;
  description: string;
  category: string;
  subject: string;
  categoryId: number;
  institution: number;
}

export interface TestQuestions {
  text: string;
  type: string;
  point: number;
  option1: string;
  option1Status: string | null;
  option2: string;
  option2Status: string;
  option3: string;
  option3Status: null | string;
  option4: string;
  option4Status: null | string;
  option5: null | string;
  option5Status: null | string;
}

export interface TestDetails {
  date: string;
  time: string;
  duration: string;
  timeZone: string | undefined;
  maxAttempt: number;
  passMarkUnit: number;
  maxScore: number;
  passMark: number;
  questions: Array<TestQuestions>;
}

interface ContextValues {
  testId: number;
  testData: TestDetails;
  testCategory: string;
  setTestId: Dispatch<React.SetStateAction<number>>;
  setTestData: Dispatch<React.SetStateAction<TestDetails>>;
  setTestCategory: Dispatch<React.SetStateAction<string>>;
}

const defaultValue = {
  testId: 0,
  testCategory: '',
  testData: {
    date: '',
    time: '',
    duration: '',
    timeZone: '',
    maxAttempt: 0,
    passMarkUnit: 1,
    maxScore: 0,
    passMark: 0,
    questions: [
      {
        text: '',
        type: '',
        point: 0,
        option1: '',
        option1Status: null,
        option2: '',
        option2Status: '',
        option3: '',
        option3Status: null,
        option4: '',
        option4Status: null,
        option5: null,
        option5Status: null,
      },
    ],
  },
  setTestId: function (value: React.SetStateAction<number>): void {
    value;
    throw new Error('Function not implemented.');
  },
  setTestData: function (value: React.SetStateAction<TestDetails>): void {
    value;
    throw new Error('Function not implemented.');
  },
  setTestCategory: function (value: React.SetStateAction<string>): void {
    value;
    throw new Error('Function not implemented.');
  },
};

export const TestContext = createContext<ContextValues>(defaultValue);

export const TestProvider = ({ children }: ProviderProps) => {
  const [testData, setTestData] = useState<TestDetails>(defaultValue.testData);
  const [testCategory, setTestCategory] = useState<string>(
    defaultValue.testCategory
  );
  const [testId, setTestId] = useState(0);

  return (
    <TestContext.Provider
      value={{
        testId,
        setTestId,
        testData,
        setTestData,
        testCategory,
        setTestCategory,
      }}
    >
      {children}
    </TestContext.Provider>
  );
};
